var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.success && _vm.show)?_c('div',{staticClass:"err-message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):(_vm.success && _vm.show)?_c('div',{staticClass:"suc-message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }